import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ContingentSubscription } from '@vi-iot/client';

@Component({
  selector: 'app-booking-contingent-subscription-list',
  templateUrl: './booking-contingent-subscription-list.component.html',
  styleUrls: ['./booking-contingent-subscription-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingContingentSubscriptionListComponent {
  @Input() contingentSubscriptions: ContingentSubscription[];
}
